var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ flash : _vm.flash, disabled: !_vm.editable },style:({ width : _vm.width + 'px'})},[_c('flat-pickr',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"config":_vm.config},on:{"on-change":_vm.onUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }